type InstaceType = "prod" | "dev" | "backup";
let instance: InstaceType = "prod";

if (
  window.location.hostname.includes("localhost") ||
  window.location.hostname.includes("dev")
) {
  instance = "dev";
}
export const instanceName: InstaceType = instance;
